export const bogeyNumbers = [169, 168, 166, 165, 163, 162, 159];
